import { GOOGLE_SHEET_LAMBDA_URL } from '../../constants/common';
import makeGetRequest from './makeGetRequest';

/**
 * Make a GET request to Google Sheets API.
 *
 * @param ranges Range of data in A1 notation (E.g. Sheet1!A2:B2 refers to the first two cells in the top two rows of Sheet1).
 * @returns The data in the specified range.
 */
const fetchGoogleSheetData = async (ranges: string): Promise<any> => {
  const url = formatQueryParameters({ ranges });

  return await makeGetRequest(url).then((response) => response.json());
};

const formatQueryParameters = (params: Record<string, string>): string => {
  const queryString = new URLSearchParams(params).toString();
  return `${GOOGLE_SHEET_LAMBDA_URL}?${queryString}`;
};

export default fetchGoogleSheetData;
